import React, { useState, useEffect } from "react";
// @material-ui/core components
import { withStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from "@material-ui/core/FormControlLabel";
// @material-ui/icons
import ArrowBack  from "@material-ui/icons/ArrowBack";
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/EditLocation';
import WorkIcon from '@material-ui/icons/Work';
import CheckBoxIcon from '@material-ui/icons/CheckCircle';
import HomeIcon from '@material-ui/icons/Home';
import ApartmentIcon from '@material-ui/icons/Apartment';
import StorefrontIcon from '@material-ui/icons/Storefront';
import MapIcon from '@material-ui/icons/Map';
import PaymentIcon from '@material-ui/icons/Payment';
import AssignmentInd from '@material-ui/icons/AssignmentInd';
import Comment from '@material-ui/icons/Comment';
import MoneyIcon from 'assets/img/money.png';
import MPIcon from 'assets/img/mercadopago.png';

import MotorcycleIcon from '@material-ui/icons/Motorcycle';
// core components
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";

import axios from 'axios';

import Link from '@material-ui/core/Link';

import myCookies from 'universal-cookie';

import { renovaJWT, BS_ALE, geraHorarios, removeEComercial, geraJson, validaCpfCnpj } from 'funcs/MyFuncs.js';

import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";

import { IconButton, Input } from "@material-ui/core";

import styles from "assets/jss/material-kit-react/views/carrinhoCompra.js";
import  "assets/css/CarrinhoCompra.css";
import 'prevent-pull-refresh';

import Confirmacao from "components/Dialogs/Confirmacao.js";

import CurrencyInput  from "react-currency-input";
import TextField from '@material-ui/core/TextField';

import MaskedInput from 'react-text-mask';

const delayProcessando     = 0;
const tempoMinProcess      = 0;

function CPFMaskInput(props) {
    const { inputRef, ...other } = props;
  
    return (
      <MaskedInput
        {...other}
        ref={(ref) => {
          inputRef(ref ? ref.inputElement : null);
        }}
        mask={[/[1-9]/, /\d/,  /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/,]}
      />
    );
}

function NenhumMaskInput(props) {
    const { inputRef, ...other } = props;
  
    return (
      <MaskedInput
        {...other}
        ref={(ref) => {
          inputRef(ref ? ref.inputElement : null);
        }}
        mask={[""]}
      />
    );
}

function CNPJMaskInput(props) {
    const { inputRef, ...other } = props;
  
    return (
      <MaskedInput
        {...other}
        ref={(ref) => {
          inputRef(ref ? ref.inputElement : null);
        }}
        mask={[/[1-9]/, /\d/,  '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/,]}
      />
    );
}

class CarrinhoCompra extends React.Component {

    btnAddTroco;
    keyboardIsProbablyOpen = false;

    MPFormData;

    arrPosItems  = [];    
    arrMenuItems = [];
    cardBody     = null;
    myMenu       = null;
    cabecalho    = null;

    ultElementMenu = -1;

    fullWindowHeight = 0;

    firstTime = false;

    constructor(props) {
        super(props);
        
        let localCart = localStorage.getItem(global.ProductObj.chaveLocalStorage);
        console.log('ZYZYZYZYZ ---- ' + localCart);
        localCart = JSON.parse(localCart);
        //load persisted cart into state if it exists
        if (!localCart) {
            localCart = [];
        }

        this.state = [];

        if (props.location.state){
            if (props.location.state.stateFinalizaCompra){
                this.state = props.location.state.stateFinalizaCompra;
            }else{
                this.state = { 
                    carrinhoCompra: localCart,
        
                    alertaSelecionaEndereco: false,
                    alertaSelecionaPagamento: false,
                    alertaDocNota: false,
                    alertaTroco: false,
                    finalizandoPedido: false,
                    alertaDesejaNota: false,
        
                    edit_tipoDocNota: "cpf",
                    cli_cpf_edit: "",

                    edit_tipoEntrega: "retirada",
        
                    tipoDocNota : "nenhum",
                    docDocNota  : "",
        
                    listaPags : [],
                    formaPagamentoAtual : null,
                    tmpFormaPagTroco : [],
        
                    tmpQtdProd: 0,
                    tmpProdSelect : [],
                    tmpProdIndex : -1,
                    alertaConfExc: false,

                    ped_obsped : '',
        
                    taxaEntrega: 0,
                };
            }
        }else{
            this.state = { 
                carrinhoCompra: localCart,
    
                alertaSelecionaEndereco: false,
                alertaSelecionaPagamento: false,
                alertaDocNota: false,
                alertaTroco: false,
                finalizandoPedido: false,
                alertaDesejaNota: false,
    
                edit_tipoDocNota: "cpf",
                cli_cpf_edit: "",

                edit_tipoEntrega: "retirada",
    
                tipoDocNota : "nenhum",
                docDocNota  : "",
    
                listaPags : [],
                formaPagamentoAtual : null,
                tmpFormaPagTroco : [],
    
                tmpQtdProd: 0,
                tmpProdSelect : [],
                tmpProdIndex : -1,
                alertaConfExc: false,
    
                taxaEntrega: 0,
            };
        }
        

        this.updateDimensions = this.updateDimensions.bind(this);
        this.carregaDados = this.carregaDados.bind(this);

    }

    carregaDados = () => {
        if (global.myToken){
            
            console.log(' ZZZZZZ - ' + global.myToken);

            try {
                // here place your login logic     
                      
                var CancelToken = axios.CancelToken;
    
                const {log_senha, log_usu} = this.state;
            
                var parametros = 
                "&partoken="    + global.myToken +
                "&pargrures=" + global.cod_grurest +
                "&parres=" + global.cod_restaurante +
                "&parverapp=" + '99';
        
                console.log("zzzz - " + parametros);

                console.log('TIMEIN');
                let source = CancelToken.source();
                setTimeout(() => {
                    source.cancel();
                    console.log('TIMEOUT');
                }, global.timeOutTimer);
        
                
                axios.post(
                    global.siteurl + 'cliente_info.php', 
                    parametros,
                    {
                    cancelToken: source.token,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded', // <-- Specifying the Content-Type
                    },
                    withCredentials: true,
                }).then((response) => {
                    var responseData = response.data;
                    console.log('TTTTTTTTTTTTT');
                    if (responseData.resposta == "2"){
                    }else if (responseData.resposta == "0") {
                        global.myToken = "";
                        this.setState({
                            myToken : "",
                            loading: false,
                        });
                    }else{
                        console.log( JSON.stringify(responseData) );

                        var taxaEntrega = 0;
                        responseData.enderecos.map((value, index) => {
                            if (value.enderecoAtivo == '1'){
                                taxaEntrega = (value.taxaentrega_bairro > 0) ? value.taxaentrega_bairro : value.taxaentrega_cep;
                            }
                        });

                        taxaEntrega = (taxaEntrega) ? taxaEntrega : 0;

                        if (typeof(taxaEntrega) === 'string'){
                            taxaEntrega    = parseFloat(taxaEntrega);
                        }

                        this.setState({ 
                            cli_nome  : responseData.nome,
                            cli_tele  : responseData.telefone,
                            cli_tipo  : responseData.tipo,
                            cli_vericod : '',
                            cli_email : responseData.email,
                            cli_cpf   : responseData.cpf,
                            cli_enderecos : responseData.enderecos,

                            cli_tele_edit : responseData.telefone,
                            cli_nome_edit : responseData.nome,
                            cli_cpf_edit  : (this.state.cli_cpf_edit == "") ? responseData.cpf : this.state.cli_cpf_edit,

                            taxaEntrega : taxaEntrega,

                            loading: false,
                        }, () => {
                            if (this.firstTime){
                                this.firstTime = false;
                                this.trocaEndereco();
                            }
                        });
                    }
                })
                .catch((error) =>{
                    
                    if(axios.isCancel(error)){
        
                        BS_ALE(this,  'Atenção', 'Não foi possível efetuar a solicitação, verifique sua conexão e tente novamente. \nCOD 021', [{text: 'OK', onPress: () => this.closeProgress()},],{cancelable: false},);
                
                    }
                    else{
                
                        BS_ALE(this,  'Atenção', 'Não foi possível efetuar a solicitação, verifique sua conexão e tente novamente. \nCOD 022', [{text: 'OK', onPress: () => this.closeProgress()},],{cancelable: false},);
                
                    }
                });
    
            } catch (err) {
                console.log('error signing up: ', err)
            }       
        }else{
            this.setState({
                loading: false,
            });
        }
    }

    updateDimensions() {
        var alturaScroll = document.body.scrollHeight - window.innerHeight;
        var scrolledY    = window.scrollY;

        var alturaItems  = 0;

        this.arrPosItems.map((item, index) => {
            alturaItems += (item) ? item.clientHeight : 0;
        });

        var proporcao = alturaItems / (alturaScroll);

        var tmpPos = 0;
        var itemAtual = 0;

        for (var i = 0; i < this.arrPosItems.length; i++){
            var tmpItem = this.arrPosItems[i];
            tmpPos += (tmpItem) ? tmpItem.clientHeight : 0;

            if ( (scrolledY * proporcao) < ( ( (this.cabecalho) ? tmpPos + (this.cabecalho.clientHeight) : tmpPos) - this.state.scrollMarginTop) ){
                break;
            }else{
                itemAtual = (i >= (this.ultElementMenu)) ? this.ultElementMenu : i + 1;
            }
        }        

        if (this.state.posItemClicado == -1){
            if (itemAtual !== this.state.itemAtivo) {
                this.setState({ itemAtivo: itemAtual});

                if (itemAtual > 0){
                    this.myMenu.scrollTo({left: this.arrMenuItems[itemAtual].offsetLeft - 30, behavior: 'smooth'})
                }else{
                    this.myMenu.scrollTo({left: 0, behavior: 'smooth'})
                }
            }
        }else if (scrolledY == this.state.posItemClicado){

            if (this.state.eventClicado == -1){
                if (itemAtual !== this.state.itemAtivo) {
                    this.setState({ itemAtivo: itemAtual});
                }
    
                if (itemAtual > 0){
                    this.myMenu.scrollTo({left: this.arrMenuItems[itemAtual].offsetLeft - 30, behavior: 'smooth'})
                }else{
                    this.myMenu.scrollTo({left: 0, behavior: 'smooth'})
                }
                this.setState({ 
                    posItemClicado: -1,
                });
            }else{
                this.myMenu.scrollTo({left: this.arrMenuItems[this.state.eventClicado].offsetLeft - 30, behavior: 'smooth'})
                this.setState({ 
                    itemAtivo: this.state.eventClicado,
                    posItemClicado: -1,
                    eventClicado : -1,
                });
            }
        }else{
            if (itemAtual !== this.state.itemAtivo) {
                this.setState({ itemAtivo: itemAtual});
            }
        }


    }

    closeProgress = () => {
        this.setState({
            loading: false,
        });
    }

    setEnderecoAtivo(id) {

        
        try {
            // here place your signup logic     
            
            var CancelToken = axios.CancelToken;
    
            var parametros = 
            "parendati="  + id     +
            "&partoken="  + global.myToken +
            "&parres="    + global.cod_restaurante +
            "&pargrures=" + global.cod_grurest +
            "&parverapp=" + '99';
    
            console.log('TIMEIN');
            let source = CancelToken.source();
            setTimeout(() => {
                source.cancel();
                console.log('TIMEOUT');
            }, global.timeOutTimer);    
            
            axios.post(
                global.siteurl + 'cliente_mudaendati.php', 
                parametros,
                {
                cancelToken: source.token,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded', // <-- Specifying the Content-Type
                },
                withCredentials: true,
            }).then((response) => {
                var responseData = response.data;
                this.closeProgress();
                if (responseData.resposta == '1') {
                    this.setState({
                        alertaSelecionaEndereco : false,
                    },() => this.carregaDados());
                    
                }else{
                    BS_ALE(this,  'Atenção', responseData.msg, [{text: 'OK', onPress: () => console.log('OK Pressed')},],{cancelable: false},);
                }
            })
            .catch((error) =>{
                
                if(axios.isCancel(error)){
    
                    BS_ALE(this,  'Atenção', 'Não foi possível efetuar a solicitação, verifique sua conexão e tente novamente. \nCOD 021', [{text: 'OK', onPress: () => this.closeProgress()},],{cancelable: false},);
            
                }
                else{
            
                    BS_ALE(this,  'Atenção', 'Não foi possível efetuar a solicitação, verifique sua conexão e tente novamente. \nCOD 022', [{text: 'OK', onPress: () => this.closeProgress()},],{cancelable: false},);
            
                }
            });
        } catch (err) {
            console.log('error signing up: ', err)
        }
    }

    componentDidMount(){

        const { navigation } = this.props;

        let localCart = localStorage.getItem(global.ProductObj.chaveLocalStorage);
        localCart = JSON.parse(localCart);
        //load persisted cart into state if it exists
        if (!localCart) {
            localCart = [];
        }

        let meuToken = localStorage.getItem(global.chaveLocalLogin);
        meuToken = meuToken;

        global.myToken = meuToken;
        this.setState({ 
            myToken        : meuToken,
            carrinhoCompra : localCart,
            estadoLogin    : [0]
        }, () => {
            this.firstTime = true;
            this.carregaDados();
        });   
                
        if (window.visualViewport){
            this.fullWindowHeight = window.visualViewport.height;
            window.visualViewport.addEventListener('resize', this.handleResize);
        }else{
            this.fullWindowHeight = window.innerHeight;
        }
    }

    handleResize = () => {
        var fullWindowHeight = this.fullWindowHeight;
        if(window.visualViewport.height == fullWindowHeight) {
            if (this.keyboardIsProbablyOpen){
                this.keyboardIsProbablyOpen = false;
            }                
        } else if(window.visualViewport.height < fullWindowHeight*0.9) {

            
            if (!this.keyboardIsProbablyOpen){
                setTimeout( () => {
                    window.scrollTo(0,5000);
                }, 500);
                this.keyboardIsProbablyOpen = true;
            }
        }
    }

    componentWillUnmount = () => {
        window.removeEventListener('scroll', this.updateDimensions);

        if (window.visualViewport){
            window.visualViewport.removeEventListener("resize", this.handleResize);
        }
        
    }

    renderHeader = () => {

        return (
            <div style={{flexGrow: 1, justifyContent:'center', alignItems: 'center', fontSize: '20px', }}>
                <IconButton
                color="inherit"
                style={{padding: '7px'}}
                onClick={() => {
                    this.props.history.push('carrinho-compra');
                }}
                >
                  <ArrowBack />
                </IconButton>
                Finalizar Compra
            </div>
        );
    }

    renderStyleShadow(ativo = false) {
        

        var arrStyle = {};

        if (ativo){
            arrStyle = {
                boxShadow: '0px 0px 3px 2px rgba(181,0,0,0.5)'
            };
        }

        return arrStyle;
    }

    renderIcon( identificacao, ativo = false ) {

        var cor = (ativo) ? '#c00' : '#777';

        if (ativo){
            return (<CheckBoxIcon style={{margin: 'auto', color: cor}} />);
        }

        switch (identificacao){
            case "Casa":
                return (<HomeIcon style={{margin: 'auto', color: cor}} />);
            case "Trabalho":
                return (<WorkIcon style={{margin: 'auto', color: cor}} />);
            case "Apartamento":
                return (<ApartmentIcon style={{margin: 'auto', color: cor}} />);
            case "RETIRADA":
                return (<StorefrontIcon style={{margin: 'auto', color: cor}} />);
            default:
                return (<MapIcon style={{margin: 'auto', color: cor}} />);                                

        }
    }

    trocaEndereco() {

        var tipoEntrega = "retirada";

        if (this.state.cli_enderecos) {
            this.state.cli_enderecos.map( (item, index) => {
                if (item.enderecoAtivo == '1'){
                    if (item.identificacao == "RETIRADA"){
                        tipoEntrega   = "retirada";
                    }else{
                        tipoEntrega   = "entrega";
                    }
                    
                }
            })
        }

        this.setState({
            alertaSelecionaEndereco : true,
            edit_tipoEntrega : tipoEntrega,
        });
    }

    renderTabEndereco() {
        return (
            <div style={{borderRadius: '8px', backgroundColor: '#efefef', padding: '6px', margin: '10px', marginTop: '0px'}}>
                {(this.state.cli_enderecos) ? this.state.cli_enderecos.map( (item, index) => {

                    var enderecoAtivo = (item.enderecoAtivo == '1');

                    if (enderecoAtivo){
                        if ( (item.identificacao) && (item.identificacao != "") ) {

                            var enderecoFinal = '';
    
                            if (item.identificacao == "RETIRADA"){
                                enderecoFinal = (global.restEndereco != "") ? global.restEndereco : "Vou retirar meus produtos na loja";
                            }else{
                                if (item.rua.length > 0) {
                                    enderecoFinal = enderecoFinal + item.rua;
                                }
            
                                if (item.numero.length > 0) {
                                    if (enderecoFinal.length > 0) {
                                        enderecoFinal = enderecoFinal + ', ';
                                    }
            
                                    enderecoFinal = enderecoFinal + item.numero;
                                }
            
                                if (item.complemento.length > 0) {
            
                                    if (enderecoFinal.length > 0) {
                                        enderecoFinal = enderecoFinal + ', ';
                                    }
            
                                    enderecoFinal = enderecoFinal + item.complemento;
                                }
            
                                if (item.referencia.length > 0) {
            
                                if (enderecoFinal.length > 0) {
                                    enderecoFinal = enderecoFinal + ', ';
                                }
            
                                enderecoFinal = enderecoFinal + item.referencia;
                                }
            
                                if (item.bairro.length > 0) {
            
                                    if (enderecoFinal.length > 0) {
                                        enderecoFinal = enderecoFinal + ', ';
                                    }
            
                                enderecoFinal = enderecoFinal + item.bairro;
                                }
            
                                if (item.cidade.length > 0) {
            
                                    if (enderecoFinal.length > 0) {
                                        enderecoFinal = enderecoFinal + ' - ';
                                    }
            
                                enderecoFinal = enderecoFinal + item.cidade;
                                }
            
                                if (item.estado.length > 0) {
            
                                    if (enderecoFinal.length > 0) {
                                        enderecoFinal = enderecoFinal + ' - ';
                                    }
            
                                enderecoFinal = enderecoFinal + item.estado;
                                }
            
                                if (item.cep.length > 0) {
            
                                    if (enderecoFinal.length > 0) {
                                        enderecoFinal = enderecoFinal + ' - ';
                                    }
            
                                enderecoFinal = enderecoFinal + item.cep;
            
                                }
                            }
                        }else{
    
                            var enderecoFinal = '';
        
                            if (item.complemento.length > 0) {
        
                                if (enderecoFinal.length > 0) {
                                    enderecoFinal = enderecoFinal + ', ';
                                }
        
                                enderecoFinal = enderecoFinal + item.complemento;
                            }
        
                            if (item.referencia.length > 0) {
        
                            if (enderecoFinal.length > 0) {
                                enderecoFinal = enderecoFinal + ', ';
                            }
        
                            enderecoFinal = enderecoFinal + item.referencia;
                            }
        
                            if (item.bairro.length > 0) {
        
                                if (enderecoFinal.length > 0) {
                                    enderecoFinal = enderecoFinal + ', ';
                                }
        
                            enderecoFinal = enderecoFinal + item.bairro;
                            }
        
                            if (item.cidade.length > 0) {
        
                                if (enderecoFinal.length > 0) {
                                    enderecoFinal = enderecoFinal + ' - ';
                                }
        
                            enderecoFinal = enderecoFinal + item.cidade;
                            }
        
                            if (item.estado.length > 0) {
        
                                if (enderecoFinal.length > 0) {
                                    enderecoFinal = enderecoFinal + ' - ';
                                }
        
                            enderecoFinal = enderecoFinal + item.estado;
                            }
        
                            if (item.cep.length > 0) {
        
                                if (enderecoFinal.length > 0) {
                                    enderecoFinal = enderecoFinal + ' - ';
                                }
        
                            enderecoFinal = enderecoFinal + item.cep;
        
                            }
    
                            
                        }
    
                        var styleTeste = this.renderStyleShadow(enderecoAtivo);
                        console.log(JSON.stringify(styleTeste));
    
                        return (
                            <div style={Object.assign({}, {marginBottom: '0px', backgroundColor: '#fff', padding: '10px', paddingLeft: '6px', paddingRight: '6px', borderRadius: '8px', display: 'flex', flexDirection: 'row', }, styleTeste)}>
                                <div onClick={() => this.trocaEndereco()} style={{width: '90%', paddingLeft: '10px'}}>
                                    <div style={{fontSize: '15px', fontWeight: '500', color: (enderecoAtivo) ? '#c00' : '#000'}}>{ ( (item.identificacao) && (item.identificacao != "") ) ? ((item.identificacao == 'RETIRADA') ? global.nome_rest : item.identificacao) : ( item.rua + ', ' + item.numero)}</div>
                                    <div style={{fontSize: '14px', fontWeight: (item.identificacao == 'RETIRADA') ? '500' : '400', color: (item.identificacao == 'RETIRADA') ? '#000' : '#777', whiteSpace: 'break-spaces'}}>{enderecoFinal}</div>
                                    {this.renderPrevisao(item)}
                                </div>
                                <div onClick={() => {
                                    if (item.identificacao != 'RETIRADA') {
                                        this.trocaEndereco()
                                    }
                                } } style={{width: '10%', minWidth: '48px', display: 'flex'}}>
                                    <EditIcon style={{margin: 'auto', fontSize: '42px', color: '#c00'}} />
                                </div>
                            </div>
                        );
                    }                    
                }) : null}
            </div>
        );
    }

    renderValTroco(item) {
        if (item.valTroco){
            if (item.valTroco.replace(',', '.') > 0){

                var valor_compra = 0;

                this.state.carrinhoCompra.map((item, index) => {
                    valor_compra += (item.valorUnit * item.qtde);
                });

                const desconto    = Math.floor(((valor_compra) * (global.descontoApp / 100)) * 100) / 100;

                var total_ped    = (valor_compra + this.state.taxaEntrega - desconto).toFixed(2);

                var valorTroco   =  (item.valTroco.replace(',', '.') - total_ped).toFixed(2).replace('.', ',');

                return (
                    <div style={{display: 'flex', flexDirection: 'row'}}>
                        <text style={{marginRight: '30px', fontSize: '16px', color: '#aaa', fontWeight: '400'}} >{'Troco para: R$ ' + item.valTroco}</text>        
                        <text style={{marginRight: '30px', fontSize: '16px', color: '#aaa', fontWeight: '400'}} >{'Troco: R$ ' + valorTroco}</text>        
                    </div>                
                );
            }
        }
    }

    renderObsPedido() {
        return (
            <div style={{borderRadius: '8px', width: '100%', padding: '7px 0px', backgroundColor: '#fff', display: 'flex', flexDirection: 'column'}}>
                <div style={{display: 'flex', flexDirection: 'column'}}>
                    <div style={{width: '100%', display: 'flex'}}>
                        <Comment />
                        <text style={{marginRight: '30px', marginLeft: '10px', fontSize: '16px', color: '#555', fontWeight: '500'}} >{"Observações do pedido"}</text>
                    </div>
                    <div style={{width: '100%', display: 'flex'}}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            name="ped_obsped"
                            type="text"
                            id="ped_obsped"
                            autoComplete="ped_obsped"
                            value={this.state.ped_obsped}
                            onChange={this.handleChange}
                        />
                    </div>
                </div>
            </div>
        );
    }

    renderDocNotaPreenchido() {
        if (this.state.tipoDocNota != "nenhum"){
            var tipoDoc = (this.state.tipoDocNota == "cpf") ? "CPF" : "CNPJ";
            return (
                <div style={{display: 'flex', flexDirection: 'row'}}>
                    <text style={{marginRight: '30px', fontSize: '16px', color: '#aaa', fontWeight: '400'}} >{ tipoDoc + ': ' + this.state.docDocNota}</text>
                </div>                
            );
        }
    }

    renderDocNota() {
        return (
            <div style={{borderRadius: '8px', width: '100%', padding: '7px 0px', backgroundColor: '#fff', display: 'flex', flexDirection: 'column'}}>
                <div style={{display: 'flex', flexDirection: 'row'}}>
                    <div style={{width: '70%', display: 'flex'}}>
                        <AssignmentInd />
                        <text style={{marginRight: '30px', marginLeft: '10px', fontSize: '16px', color: '#555', fontWeight: '500'}} >{"CPF/CNPJ na nota"}</text>
                    </div>
                    <div style={{width: '30%', display: 'flex'}}>
                        <a
                            onClick={() => {
                                this.setState({
                                    alertaDocNota: true,
                                    finalizandoPedido: false,
                                    edit_tipoDocNota  : (this.state.docDocNota != "") ? this.state.tipoDocNota  : "cpf",
                                    cli_cpf_edit      : (this.state.docDocNota != "") ? this.state.docDocNota   : this.state.cli_cpf,
                                });
                            }}
                            style={{color: '#3496eb', fontSize: '17px', fontWeight: '550', textDecoration: 'underline', textAlign: 'right', width: '100%'}}
                        >
                            { (this.state.tipoDocNota != "nenhum") ? "Alterar" : "Adicionar"}
                        </a>
                    </div>
                </div>
                {this.renderDocNotaPreenchido()}
            </div>
        );
    }

    renderTituloEntrega() {
        //!@#!@#
        var IconeEntrega = <MotorcycleIcon />;
        var msgEntrega   = "Entrega";

        if (this.state.cli_enderecos) {
            this.state.cli_enderecos.map( (item, index) => {
                if (item.enderecoAtivo == '1'){
                    if (item.identificacao == "RETIRADA"){
                        IconeEntrega = <StorefrontIcon />;
                        msgEntrega   = "Retirada";
                    }else{
                        IconeEntrega = <MotorcycleIcon />;
                        msgEntrega   = "Entrega";
                    }
                    
                }
            })
        }

        return (
            <div style={{borderRadius: '8px', width: '100%', padding: '7px 0px', backgroundColor: '#fff', display: 'flex'}}>
                <div style={{width: '80%', display: 'flex'}}>
                    {IconeEntrega}
                    <text style={{marginRight: '30px', marginLeft: '10px', fontSize: '20px', color: '#555', fontWeight: '500'}} >Pedido para <text style={{color: '#c00', fontWeight: 'bold'}}>{msgEntrega}</text></text>
                </div>
                <div style={{width: '20%', display: 'flex'}}>
                    <a
                        onClick={() => {
                            this.trocaEndereco();
                        }}
                        style={{color: '#3496eb', fontSize: '17px', fontWeight: '550', textDecoration: 'underline', textAlign: 'right', width: '100%'}}
                    >
                        { "Mudar"}
                    </a>
                </div>
            </div> 
        );
    }

    renderFormaAtualPag() {

        const { classes } = this.props;

        if (this.state.formaPagamentoAtual){
            var item = this.state.formaPagamentoAtual;

            var iconePagamento = (item.online) ? MPIcon : MoneyIcon;

            return (
                <div style={{borderRadius: '8px', width: '100%', padding: '7px 0px', backgroundColor: '#fff', display: 'flex', flexDirection: 'column'}}>
                    <div style={{display: 'flex', flexDirection: 'row'}}>
                        <div style={{width: '70%'}}>
                            <img src={iconePagamento} style={{marginRight: '5px', height: (item.online) ? '28px' : '20px'}}/>
                            <text style={{marginRight: '30px', fontSize: '15px', color: '#555', fontWeight: '600'}} >{item.nome}</text>
                        </div>
                        <div style={{width: '30%', display: 'flex'}}>
                            <a
                                onClick={() => {
                                    this.carregaFormasPag();
                                }}
                                style={{color: '#3496eb', fontSize: '17px', fontWeight: '550', textDecoration: 'underline', textAlign: 'right', width: '100%'}}
                            >
                                { "Mudar"}
                            </a>
                        </div>
                    </div>
                    {this.renderValTroco(item)}
                </div> 
            );
        }else{
            return (
                <div style={{borderRadius: '8px', width: '100%', padding: '7px 0px', backgroundColor: '#fff', display: 'flex'}}>
                    <div style={{width: '70%', display: 'flex'}}>
                        <PaymentIcon />
                        <text style={{marginRight: '30px', marginLeft: '10px', fontSize: '16px', color: '#555', fontWeight: '500'}} >{"Forma de pagamento"}</text>
                    </div>
                    <div style={{width: '30%', display: 'flex'}}>
                        <a
                            onClick={() => {
                                this.carregaFormasPag();
                            }}
                            style={{color: '#3496eb', fontSize: '17px', fontWeight: '550', textDecoration: 'underline', textAlign: 'right', width: '100%'}}
                        >
                            { "Escolher"}
                        </a>
                    </div>
                    
                    
                </div> 
            );
        }
    }

    renderLista = (items) => {
        const { classes } = this.props;
        var resultado = null;

        return items.map((item, index) => {

            var sabor = item.sabores;
            var qtde  = item.qtde;

            var valorTot = (qtde * item.valorUnit).toFixed(2).replace('.', ',');

            var saboresNome = "";

            item.sabores.map( (value, index) => {

                var prod = value.produto;

                saboresNome += (saboresNome.length > 0) ? ' ' : '';

                saboresNome += ((item.qtdeSabores > 1) ? '1/' + item.qtdeSabores + ' ' : '') + prod.nomeProduto;
            });

            var strQtde = ((qtde % 1 != 0) ? qtde.toFixed(3) : qtde.toString()).replace('.', ',');

            return (
                <div style={{width: '100%', display: 'flex', flexDirection: 'column', margin: '5px 0px'}} onClick={() => {
                    
                }}>
                    <div style={{width: '100%', display: 'flex', flexDirection: 'row'}}>
                        <div style={{width: '70%', display: 'flex', flexDirection: 'column'}}>
                            <text style={{fontSize: '16px', color: '#000', fontWeight: '420'}} >{saboresNome}</text>
                            <text style={{fontSize: '16px', color: '#888', fontWeight: 'normal'}} >{strQtde + " x " + item.valorUnit.replace('.', ',')}</text>
                        </div>   
                        <div style={{width: '30%'}}>
                            <div style={{fontSize: '17px', fontWeight: '420', marginBottom: 'auto', marginTop: '0px', marginLeft: 'auto', marginRight: '5px', width: 'fit-content', textAlign: 'right'}}>R$ {valorTot}</div>
                        </div>
                    </div>
                </div>
            );
            
            
        });
    }

    renderCarrinho = () => {

        const { classes } = this.props;
        
        return (

            <div style={{ scrollMarginTop: (this.state.scrollMarginTop + "px"), maxWidth: '100%', }}>
                <div>
                    <div>
                        <div style={{display: 'flex', flexDirection: 'column', }}>
                            {this.renderLista(this.state.carrinhoCompra)}
                        </div>        
                    </div> 
                </div>
            </div>  

        );
    }

    renderProdutos() {
        return(
            this.renderCarrinho()
        );
    }

    renderInfoCompra() {

        const { classes } = this.props;

        return (
            <div>
                <div style={{display: 'flex', flexDirection: 'column', padding: '0px 6px', margin: '10px 10px 10px 10px',}}>
                    {this.renderTituloEntrega()}
                </div>
                {this.renderTabEndereco()}
                <div style={{display: 'flex', flexDirection: 'column', margin: '6px 10px', }}>
                    <div className={classes.separator} style={{marginTop: '2px', marginBottom: '2px', backgroundColor: '#aaa'}} ></div>
                </div>
                <div style={{display: 'flex', flexDirection: 'column', padding: '0px 6px', margin: '0px 10px 10px 10px', }}>
                    {this.renderProdutos()}
                </div>
                {this.renderMensageKG()}
                <div style={{display: 'flex', flexDirection: 'column', margin: '6px 10px', }}>
                    <div className={classes.separator} style={{marginTop: '2px', marginBottom: '2px', backgroundColor: '#aaa'}} ></div>
                </div>
                <div style={{display: 'flex', flexDirection: 'column', padding: '0px 6px', margin: '10px 10px 10px 10px', }}>
                    {this.renderResumoPed()}
                </div>
                <div style={{display: 'flex', flexDirection: 'column', margin: '6px 10px', }}>
                    <div className={classes.separator} style={{marginTop: '2px', marginBottom: '2px', backgroundColor: '#aaa'}} ></div>
                </div>
                <div style={{display: 'flex', flexDirection: 'column', padding: '0px 6px', margin: '10px 10px 10px 10px',}}>
                    {this.renderFormaAtualPag()}
                </div>
                <div style={{display: 'flex', flexDirection: 'column', margin: '6px 10px', }}>
                    <div className={classes.separator} style={{marginTop: '2px', marginBottom: '2px', backgroundColor: '#aaa'}} ></div>
                </div>
                <div style={{display: 'flex', flexDirection: 'column', padding: '0px 6px', margin: '10px 10px 10px 10px',}}>
                    {this.renderDocNota()}
                </div>
                <div style={{display: 'flex', flexDirection: 'column', margin: '6px 10px', }}>
                    <div className={classes.separator} style={{marginTop: '2px', marginBottom: '2px', backgroundColor: '#aaa'}} ></div>
                </div>
                <div style={{display: 'flex', flexDirection: 'column', padding: '0px 6px', margin: '10px 10px 10px 10px',}}>
                    {this.renderObsPedido()}
                </div>
            </div>
        )
    }
    
    resolveAlertaDesejaNota = () => {
        this.setState({
            alertaDesejaNota: false,
            alertaDocNota   : true,
            finalizandoPedido : true,
        });
    }

    handleCloseDesejaNota = () => {
        this.setState({
            alertaDesejaNota: false,
        });
    }

    resolveAlertaTroco = () => {
        this.setState({
            alertaTroco: false,
            alertaDefineTroco: true,
            valorTroco: '',
            alertaSelecionaPagamento: false,
        });
    }

    handleCloseTroco = () => {
        this.setState({
            alertaTroco: false,
            alertaSelecionaPagamento: false,
            formaPagamentoAtual: this.state.tmpFormaPagTroco,
        });
    }

    selecionaPagamentoMP = () => {

        var item = {
            online   : true,
            nome     : "Mercado Pago",
            valTroco : 0
        }

        this.setState({
            formaPagamentoAtual: item,
            alertaSelecionaPagamento: false,
        });

    }

    selecionaFormaPag = (item) => {

        if (item.troco == '1'){
            this.setState({
                tmpFormaPagTroco: item,
                alertaSelecionaPagamento: false,
                alertaTroco: true,
            });

        }else{

            this.setState({
                formaPagamentoAtual: item,
                alertaSelecionaPagamento: false,
            });

        }
        
    }

    renderPagamentos() {

        const { classes } = this.props;

        return (
            <div style={{borderRadius: '8px', backgroundColor: '#fff', margin: '6px 0px 12px 0px'}}>
                {(this.state.listaPags) ? this.state.listaPags.map( (item, index) => {
                    return (
                        <div>
                            <div style={{border: "2px groove rgba(0, 0, 0, 0.05)", borderRadius: "8px", padding: "10px", marginBottom: "10px"}}>
                                <div onClick={() => {
                                    this.selecionaFormaPag(item)
                                }} style={{borderRadius: '8px', width: '100%', backgroundColor: '#fff', display: 'flex'}}>
                                    <img src={MoneyIcon} style={{marginRight: '5px', height: '22px'}}/>
                                    <text style={{marginRight: '30px', fontSize: '15px', color: '#000', display: 'flex', alignItems: 'center', }} >{item.nome}</text>
                                </div> 
                            </div>
                        </div>
                    );
                }) : null}
            </div>
        );
    }

    renderMsgTipoEntrega() {
        if (this.state.edit_tipoEntrega == "retirada"){
            return (
                <text style={{margin: 'auto auto 10px auto', color: '#099800', fontSize: '15px', fontWeight: '450'}}>Confirme a retirada clicando na loja</text>
            );
        }else{
            return (
                <text style={{margin: 'auto auto 10px auto', color: '#099800', fontSize: '15px', fontWeight: '450'}}>Confirme a entrega selecionando o endereço</text>
            );
        }
    }

    renderBtnAddEnd() {

        const { classes } = this.props;

        if (this.state.edit_tipoEntrega == "retirada"){
            return null;
        }else{
            return (
                <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    onClick={() => {
                        this.props.history.push({
                            pathname: 'usuarioinfo-addend',
                            state: { 
                                finalizandoCad: true,
                                stateFinalizaCompra: this.state
                            },
                            
                        });
                    }}
                    style={{backgroundColor: '#3496eb'}}
                >
                    Adicionar Endereço
                </Button>
            );
        }
    }

    renderEnderecos() {
        return (
            <div style={{borderRadius: '8px', backgroundColor: '#efefef', padding: '10px', paddingBottom: '0px'}}>
                {(this.state.cli_enderecos) ? this.state.cli_enderecos.map( (item, index) => {

                    if (this.state.edit_tipoEntrega == "retirada"){
                        if (item.identificacao != "RETIRADA"){
                            return null;
                        }
                    }else{
                        if (item.identificacao == "RETIRADA"){
                            return null;
                        }
                    }

                    var enderecoAtivo = (item.enderecoAtivo == '1');

                    if ( (item.identificacao) && (item.identificacao != "") ) {

                        var enderecoFinal = '';

                        if (item.identificacao == "RETIRADA"){
                            enderecoFinal = (global.restEndereco != "") ? global.restEndereco : "Vou retirar meus produtos na loja";
                        }else{
                            if (item.rua.length > 0) {
                                enderecoFinal = enderecoFinal + item.rua;
                            }
        
                            if (item.numero.length > 0) {
                                if (enderecoFinal.length > 0) {
                                    enderecoFinal = enderecoFinal + ', ';
                                }
        
                                enderecoFinal = enderecoFinal + item.numero;
                            }
        
                            if (item.complemento.length > 0) {
        
                                if (enderecoFinal.length > 0) {
                                    enderecoFinal = enderecoFinal + ', ';
                                }
        
                                enderecoFinal = enderecoFinal + item.complemento;
                            }
        
                            if (item.referencia.length > 0) {
        
                            if (enderecoFinal.length > 0) {
                                enderecoFinal = enderecoFinal + ', ';
                            }
        
                            enderecoFinal = enderecoFinal + item.referencia;
                            }
        
                            if (item.bairro.length > 0) {
        
                                if (enderecoFinal.length > 0) {
                                    enderecoFinal = enderecoFinal + ', ';
                                }
        
                            enderecoFinal = enderecoFinal + item.bairro;
                            }
        
                            if (item.cidade.length > 0) {
        
                                if (enderecoFinal.length > 0) {
                                    enderecoFinal = enderecoFinal + ' - ';
                                }
        
                            enderecoFinal = enderecoFinal + item.cidade;
                            }
        
                            if (item.estado.length > 0) {
        
                                if (enderecoFinal.length > 0) {
                                    enderecoFinal = enderecoFinal + ' - ';
                                }
        
                            enderecoFinal = enderecoFinal + item.estado;
                            }
        
                            if (item.cep.length > 0) {
        
                                if (enderecoFinal.length > 0) {
                                    enderecoFinal = enderecoFinal + ' - ';
                                }
        
                            enderecoFinal = enderecoFinal + item.cep;
        
                            }
                        }
                    }else{

                        var enderecoFinal = '';
    
                        if (item.complemento.length > 0) {
    
                            if (enderecoFinal.length > 0) {
                                enderecoFinal = enderecoFinal + ', ';
                            }
    
                            enderecoFinal = enderecoFinal + item.complemento;
                        }
    
                        if (item.referencia.length > 0) {
    
                        if (enderecoFinal.length > 0) {
                            enderecoFinal = enderecoFinal + ', ';
                        }
    
                        enderecoFinal = enderecoFinal + item.referencia;
                        }
    
                        if (item.bairro.length > 0) {
    
                            if (enderecoFinal.length > 0) {
                                enderecoFinal = enderecoFinal + ', ';
                            }
    
                        enderecoFinal = enderecoFinal + item.bairro;
                        }
    
                        if (item.cidade.length > 0) {
    
                            if (enderecoFinal.length > 0) {
                                enderecoFinal = enderecoFinal + ' - ';
                            }
    
                        enderecoFinal = enderecoFinal + item.cidade;
                        }
    
                        if (item.estado.length > 0) {
    
                            if (enderecoFinal.length > 0) {
                                enderecoFinal = enderecoFinal + ' - ';
                            }
    
                        enderecoFinal = enderecoFinal + item.estado;
                        }
    
                        if (item.cep.length > 0) {
    
                            if (enderecoFinal.length > 0) {
                                enderecoFinal = enderecoFinal + ' - ';
                            }
    
                        enderecoFinal = enderecoFinal + item.cep;
    
                        }

                        
                    }

                    var styleTeste = this.renderStyleShadow(enderecoAtivo);
                    console.log(JSON.stringify(styleTeste));

                    return (
                        <div style={Object.assign({}, {marginBottom: '10px', backgroundColor: '#fff', padding: '18px', paddingLeft: '6px', paddingRight: '6px', borderRadius: '8px', display: 'flex', flexDirection: 'row', }, styleTeste)}>
                            <div onClick={() => this.setEnderecoAtivo(item.idEndereco)} style={{width: '6%', minWidth: '40px', display: 'flex'}}>
                                {this.renderIcon(item.identificacao, enderecoAtivo)}
                            </div>
                            <div onClick={() => this.setEnderecoAtivo(item.idEndereco)} style={{width: '84%'}}>
                                <div style={{fontSize: '15px', fontWeight: '500', color: (enderecoAtivo) ? '#c00' : '#000'}}>{ ( (item.identificacao) && (item.identificacao != "") ) ? ((item.identificacao == 'RETIRADA') ? 'Retirar na Loja' : item.identificacao) : ( item.rua + ', ' + item.numero)}</div>
                                <div style={{fontSize: '14px', fontWeight: '400', color: '#777'}}>{enderecoFinal}</div>
                                {this.renderPrevisao(item)}
                            </div>
                        </div>
                    );
                }) : null}
            </div>
        );
    }

    renderPrevisao = (item) => {

        if (item.prevTempo > 0){
            return (
                <div style={{fontSize: '14px', fontWeight: '400', color: '#c00'}}>{((item.identificacao == 'RETIRADA') ? 'Previsão de retirada: ' : 'Previsão de entrega: ') + item.prevTempo + ' minutos'}</div>
            );
        }
        
    }

    renderDialogEndereco = () => {

        const { classes } = this.props;

        var entregaDelivery = 0;
        var entregaRetirada = 0;

        if (this.state.cli_enderecos) {
            for (var i = 0; i < this.state.cli_enderecos.length; i++){
                var item = this.state.cli_enderecos[i];
                if (item.identificacao == "RETIRADA"){
                    entregaRetirada   = item.prevTempo;
                }else{
                    entregaDelivery   = item.prevTempo;
                }
            }
        }
        
        if ((this.state.alertaSelecionaEndereco)){

            return(
                <Dialog
                    open={this.state.alertaSelecionaEndereco}
                    onClose={this.handleCloseAlerta}
                    disableBackdropClick 
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    classes={{ container: classes.root, paper: classes.paper }}
                    style={{maxWidth: '720px', margin: '0 auto 0 auto'}}
                >
                    <DialogContent>
                        <div style={{display: 'flex', flexDirection: 'column', marginTop: '10px', marginBottom: '30px'}}>
                            <text style={{margin: 'auto', fontSize: '17px', fontWeight: '500'}}>Pedido para:</text>
                            <RadioGroup style={{display: 'flex', flexDirection: 'row', marginBottom: '8px'}} value={this.state.edit_tipoEntrega} onChange={this.handleRadioEntregaChange}>
                                <FormControlLabel style={{width: '40%'}} value="retirada" control={<Radio />} label={"Retirada" + ((entregaRetirada > 0) ? (" (+-" + entregaRetirada + "min)") : "")} />
                                <FormControlLabel style={{width: '40%', margin: 'auto 0px auto auto'}} value="entrega"  control={<Radio />} label={"Entrega" + ((entregaRetirada > 0) ? (" (+-" + entregaDelivery + "min)") : "")} />
                            </RadioGroup>
                            {this.renderMsgTipoEntrega()}
                            {this.renderEnderecos()}
                            {this.renderBtnAddEnd()}
                        </div>
                    </DialogContent>
                </Dialog>
            );
        }
    }

    carregaFormasPag = () => {
        console.log(' ZZZZZZ - ' + global.myToken);

        try {
            // here place your login logic     
                    
            var CancelToken = axios.CancelToken;

            const {log_senha, log_usu} = this.state;
        
            var parametros = 
            "&pargrures=" + global.cod_grurest +
            "&parres=" + global.cod_restaurante +
            "&parverapp=" + '99';
    
            console.log("zzzz - " + parametros);

            console.log('TIMEIN');
            let source = CancelToken.source();
            setTimeout(() => {
                source.cancel();
                console.log('TIMEOUT');
            }, global.timeOutTimer);
    
            
            axios.post(
                global.siteurl + 'pagamento_search.php', 
                parametros,
                {
                cancelToken: source.token,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded', // <-- Specifying the Content-Type
                },
                withCredentials: true,
            }).then((response) => {
                var responseData = response.data;
                console.log('TTTTTTTTTTTTT');
                if (responseData.resposta == "2"){
                }else if (responseData.resposta == "0") {
                    global.myToken = "";
                    this.setState({
                        myToken : "",
                        loading: false,
                    });
                }else{
                    this.setState({
                        listaPags: responseData.registros,
                        alertaSelecionaPagamento: true,
                    });
                }
            })
            .catch((error) =>{
                
                if(axios.isCancel(error)){
    
                    BS_ALE(this,  'Atenção', 'Não foi possível efetuar a solicitação, verifique sua conexão e tente novamente. \nCOD 021', [{text: 'OK', onPress: () => this.closeProgress()},],{cancelable: false},);
            
                }
                else{
            
                    BS_ALE(this,  'Atenção', 'Não foi possível efetuar a solicitação, verifique sua conexão e tente novamente. \nCOD 022', [{text: 'OK', onPress: () => this.closeProgress()},],{cancelable: false},);
            
                }
            });

        } catch (err) {
            console.log('error signing up: ', err)
        }  
    }

    setTrocoVal = () => {

        var pagamentoFinal = this.state.tmpFormaPagTroco;

        var valor_compra = 0;

        this.state.carrinhoCompra.map((item, index) => {
            valor_compra += (item.valorUnit * item.qtde);
        });

        const desconto    = Math.floor(((valor_compra) * (global.descontoApp / 100)) * 100) / 100;

        var total_ped    = (valor_compra + this.state.taxaEntrega - desconto).toFixed(2);

        var str_troco    = this.state.valorTroco.replace(',', '.');

        if (parseFloat(str_troco) >= parseFloat(total_ped)){

            pagamentoFinal.valTroco = (this.state.valorTroco.replace(',', '.') == total_ped) ? undefined : this.state.valorTroco;

            this.setState({
                alertaDefineTroco: false,
                formaPagamentoAtual: pagamentoFinal,
            });
        }else{
            BS_ALE(this, 'Atenção', 'O valor para troco precisa ser maior ou igual ao valor total do pedido');
        }
        
    }

    renderDialogTroco = () => {

        const { classes } = this.props;
        
        if ((this.state.alertaDefineTroco)){

            return(
                <Dialog
                    open={this.state.alertaDefineTroco}
                    onClose={this.handleCloseAlerta}
                    disableBackdropClick 
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    classes={{ container: classes.root, paper: classes.paper }}
                    style={{maxWidth: '720px', margin: '0 auto 0 auto'}}
                >
                    <DialogContent>
                        <div style={{display: 'flex', flexDirection: 'column', marginTop: '0px', marginBottom: '0px'}}>
                            <div style={{display: 'flex', flexDirection: 'column', padding: '0px 6px', margin: '10px 10px 10px 10px', }}>
                                {this.renderResumoPed()}
                            </div>
                            <div style={{width: '100%', }}><text style={{fontWeight: '415', color: '#aaa', fontSize: '24px', display: 'flex'}}><PaymentIcon style={{marginRight: '6px'}} />Troco para:</text></div>
                            <div className={classes.separator} style={{marginTop: '12px', marginBottom: '12px', backgroundColor: '#aaa'}} ></div>
                            <div className={"MuiInputBase-root MuiOutlinedInput-root MuiInputBase-fullWidth MuiInputBase-formControl"}>
                                <div tabIndex={1} autoFocus={true}></div>
                                <CurrencyInput 
                                    variant="outlined"
                                    margin="normal"
                                    required
                                    fullWidth
                                    label="Senha"
                                    decimalSeparator="," 
                                    thousandSeparator="." 
                                    prefix={""} 
                                    className="MuiInputBase-input MuiOutlinedInput-input" 
                                    style={{
                                        border: 'solid 1px #ccc',
                                        width: '100%',
                                        borderRadius: "3px",
                                        textAlign: "right"
                                    }}
                                    value={this.state.valorTroco}    
                                    onFocus={() => {
                                        this.handleResize();
                                    }}
                                    onChangeEvent={(event, value)=> this.setState({ valorTroco : value })}
                                    precision={2}/>
                            </div>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                name="log_senha"
                                label="Senha"
                                type="password"
                                id="log_senha"
                                autoComplete="current-password"
                                value={this.state.log_senha}
                                onChange={this.handleChange}
                                style={{display: "none"}}
                            />    
                            <div ref={(ref) => this.btnAddTroco = ref} style={{display: 'flex', flexDirection: 'row', margin: '12px 0 0px 0', width: '100%', paddingBottom: '12px'}}>
                                <Button onClick={() => this.setState({alertaDefineTroco: false})} color="primary" style={{backgroundColor: '#ddd', width: '50%', margin: '0 8px 0 0px', color: '#000'}}>
                                    Voltar
                                </Button>
                                <Button onClick={() => this.setTrocoVal()} color="primary" style={{backgroundColor: '#03a1fc', width: '50%', margin: '0 0 0px 8px'}}>
                                    Confirmar
                                </Button>
                            </div>                       
                        </div>
                    </DialogContent>
                </Dialog>
            );
        }
    }

    handleRadioChange = (event) => {
        this.setState({
            edit_tipoDocNota : event.target.value,
            cli_cpf_edit : "",
        });
    };

    handleRadioEntregaChange = (event) => {
        this.setState({
            edit_tipoEntrega : event.target.value,
        });
    };

    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value,
        });
    };

    setDocNota() {
        if ( validaCpfCnpj(this.state.cli_cpf_edit) ) {
            this.setState({
                tipoDocNota : this.state.edit_tipoDocNota,
                docDocNota  : this.state.cli_cpf_edit,
                alertaDocNota : false,
            }, () => {
                if (this.state.finalizandoPedido){
                    this.geraPedido();
                }
            });
        }else{

            var msg = "Você precisa inserir um CNPJ válido";

            if (this.state.edit_tipoDocNota == "cpf"){
                msg = "Você precisa inserir um CPF válido";
            }

            BS_ALE(this,  'Atenção', msg, [{text: 'OK', onPress: () => console.log('OK Pressed')},],{cancelable: false},);
        }
        
    }

    renderDialogDocNota = () => {

        const { classes } = this.props;
        
        if ((this.state.alertaDocNota)){

            var objMaskInput = NenhumMaskInput;
            var docNotaLabel = "Nenhum";

            if (this.state.edit_tipoDocNota == "cpf"){
                objMaskInput = CPFMaskInput;
                docNotaLabel = "CPF";
            }else if (this.state.edit_tipoDocNota == "cnpj"){
                objMaskInput = CNPJMaskInput;
                docNotaLabel = "CNPJ";
            }

            return(
                <Dialog
                    open={this.state.alertaDocNota}
                    onClose={this.handleCloseAlerta}
                    disableBackdropClick 
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    classes={{ container: classes.root, paper: classes.paper }}
                    style={{maxWidth: '720px', margin: '0 auto 0 auto'}}
                >
                    <DialogContent>
                        <div style={{display: 'flex', flexDirection: 'column', marginTop: '0px', marginBottom: '30px'}}>
                            <div style={{width: '100%', }}><text style={{fontWeight: '415', color: '#aaa', fontSize: '24px', display: 'flex'}}><AssignmentInd style={{marginRight: '6px'}} />CPF/CNPJ na nota</text></div>
                            <div className={classes.separator} style={{marginTop: '12px', marginBottom: '12px', backgroundColor: '#aaa'}} ></div>
                            <div>
                                <RadioGroup style={{display: 'flex', flexDirection: 'row'}} value={this.state.edit_tipoDocNota} onChange={this.handleRadioChange}>
                                    <FormControlLabel value="nenhum" control={<Radio />} label="Nenhum" />
                                    <FormControlLabel value="cpf"    control={<Radio />} label="CPF" />
                                    <FormControlLabel value="cnpj"   control={<Radio />} label="CNPJ" />
                                </RadioGroup>
                            </div>
                            <div>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    required
                                    fullWidth
                                    name="cli_cpf_edit"
                                    label={docNotaLabel}
                                    type="text"
                                    id="cli_cpf_edit"
                                    autoComplete="text"
                                    InputProps={{
                                        inputComponent: objMaskInput,
                                        value: (this.state.edit_tipoDocNota == "nenhum") ? "" : this.state.cli_cpf_edit,
                                        onChange: this.handleChange,
                                    }}
                                />
                            </div>
                            <div style={{display: 'flex', flexDirection: 'row', margin: '12px 0 12px 0', width: '100%'}}>
                                <Button onClick={() => this.setState({alertaDocNota: false})} color="primary" style={{backgroundColor: '#ddd', width: '50%', margin: '0 8px 0 0px', color: '#000'}}>
                                    Voltar
                                </Button>
                                <Button onClick={() => this.setDocNota()} color="primary" style={{backgroundColor: '#03a1fc', width: '50%', margin: '0 0 0 8px'}}>
                                    Confirmar
                                </Button>
                            </div>
                        </div>
                    </DialogContent>
                </Dialog>
            );
        }
    }
    
    renderPagamentosOnline = () => {

        const { classes } = this.props;

        var permitePagOnl = false;

        if (this.state.cli_enderecos) {

            for (var i = 0; i < this.state.cli_enderecos.length; i++){

                var item = this.state.cli_enderecos[i];

                var enderecoAtivo = (item.enderecoAtivo == '1');
    
                if (enderecoAtivo){
                    if ( (item.identificacao) && (item.identificacao != "") ) {
                        if (item.identificacao == "RETIRADA"){
                            permitePagOnl = (global.restPonBal == '1');
                            break;
                        }else{
                            permitePagOnl = (global.restPonDel == '1');
                            break;
                        }
                    }else{
                        permitePagOnl = (global.restPonDel == '1');
                        break;
                    }
                }

            }
        }

        if (permitePagOnl){
            return (
                <div>
                    <div style={{margin: "10px 0px", fontSize: '16px', fontWeight: '500', color: '#333'}}>Pagamentos Online</div>
                    <div style={{border: "2px groove rgba(0, 0, 0, 0.05)", borderRadius: "8px", padding: "10px", marginBottom: "10px"}}>
                        <div onClick={() => {
                                this.selecionaPagamentoMP()
                            }} style={{borderRadius: '8px', width: '100%', backgroundColor: '#fff', display: 'flex'}}>
                            <img src={MPIcon} style={{marginRight: '5px', height: '28px'}}/>
                            <text style={{marginRight: '30px', fontSize: '15px', color: '#000', display: 'flex', alignItems: 'center',}} >{'Mercado Pago'}</text>
                        </div> 
                    </div>
                </div>
            );
        }

    }

    renderDialogPagamento = () => {

        const { classes } = this.props;
        
        if ((this.state.alertaSelecionaPagamento)){

            return(
                <Dialog
                    open={this.state.alertaSelecionaPagamento}
                    onClose={this.handleCloseAlerta}
                    disableBackdropClick 
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    classes={{ container: classes.root, paper: classes.paper }}
                    style={{maxWidth: '720px', margin: '0 auto 0 auto'}}
                >
                    <DialogContent>
                        <div style={{display: 'flex', flexDirection: 'column', marginTop: '0px', marginBottom: '30px'}}>
                            <div style={{width: '100%', }}><text style={{fontWeight: '415', color: '#aaa', fontSize: '24px', display: 'flex'}}><PaymentIcon style={{marginRight: '6px'}} />Formas de pagamento</text></div>
                            <div className={classes.separator} style={{marginTop: '12px', marginBottom: '12px', backgroundColor: '#aaa'}} ></div>
                            {this.renderPagamentosOnline()}
                            <div style={{margin: "10px 0px", fontSize: '16px', fontWeight: '500', color: '#333'}}>Pagamentos na Entrega</div>
                            {this.renderPagamentos()}
                            <Button
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    className={classes.submit}
                                    onClick={() => {
                                        this.setState({
                                            alertaSelecionaPagamento: false
                                        });
                                    }}
                                    style={{backgroundColor: '#3496eb'}}
                                >
                                Voltar
                            </Button>
                        </div>
                    </DialogContent>
                </Dialog>
            );
        }
    }

    renderResumoPed() {

        const { classes } = this.props;

        var valor_compra = 0;

        this.state.carrinhoCompra.map((item, index) => {
            valor_compra += (item.valorUnit * item.qtde);
        });

        var prod_val    = valor_compra.toFixed(2);
        prod_val = ((prod_val.trim() == "0.00") || (prod_val.trim() == "0,00")) ? "0,00" : prod_val.replace('.', ',');
        prod_val = 'R$ ' + prod_val;
        
        var taxa_ent    = this.state.taxaEntrega;

        if (typeof(taxa_ent) === 'number'){
            taxa_ent    = taxa_ent.toFixed(2);
        }

        taxa_ent = ((taxa_ent.trim() == "0.00") || (taxa_ent.trim() == "0,00")) ? "0,00" : taxa_ent.replace('.', ',');
        taxa_ent = 'R$ ' + taxa_ent;

        const desconto    = Math.floor(((valor_compra) * (global.descontoApp / 100)) * 100) / 100;

        var total_ped    = (valor_compra + this.state.taxaEntrega - desconto).toFixed(2);
        total_ped = ((total_ped.trim() == "0.00") || (total_ped.trim() == "0,00")) ? "0,00" : total_ped.replace('.', ',');
        total_ped = 'R$ ' + total_ped;
        
        var   strDesc     = desconto.toFixed(2);
        strDesc           = ((strDesc.trim() == "0.00") || (strDesc.trim() == "0,00")) ? "0,00" : strDesc.replace('.', ',');
        strDesc = 'R$ ' + strDesc;

        return ( 
            <div style={{backgroundColor:"#", width:'100%',}}>
                <div style={{
                    backgroundColor:"#", width: '100%', flexDirection:'row', justifyContent: 'center', alignItems: 'center',
                    margin: '0px 0px', display: 'flex',
                    }}>
                    <text style={{width: '60%', textAlign:'left', fontSize: '14px', color: '#bbb', fontWeight: '400',}}>Total dos Produtos</text>
                    <text style={{width: '40%', textAlign:'right', fontSize: '14px', color: '#bbb', fontWeight: '400',}}>{prod_val}</text> 
                </div>
                {(desconto > 0) ? 
                <div style={{
                    backgroundColor:"#", width: '100%', flexDirection:'row', justifyContent: 'center', alignItems: 'center',
                    margin: '0px 0px', display: 'flex',
                        }}>
                    <text style={{width: '60%', textAlign:'left', fontSize: '14px', color: '#bbb', fontWeight: '400',}}>Desconto nos produtos</text>
                    <text style={{width: '40%', textAlign:'right', fontSize: '14px', color: '#bbb', fontWeight: '400',}}>- {strDesc}</text> 
                </div>
                : null}
                <div style={{
                        backgroundColor:"#", width: '100%', flexDirection:'row', justifyContent: 'center', alignItems: 'center',
                        margin: '0px 0px', display: 'flex',
                    }}>
                    <text style={{width: '60%', textAlign:'left', fontSize: '14px', color: '#bbb', fontWeight: '400',}}>Taxa de Entrega</text>
                    <text style={{width: '40%', textAlign:'right', fontSize: '14px', color: '#bbb', fontWeight: '400',}}>{taxa_ent}</text> 
                </div>
                <div style={{
                    backgroundColor:"#", width: '100%', flexDirection:'row', justifyContent: 'center', alignItems: 'center',
                    marginTop: 3, marginBottom: 3, paddingTop: 6, paddingBottom: 6, display: 'flex',
                    }}>
                    <text style={{width: '60%', textAlign:'left', fontSize: '17px', color: '#555', fontWeight: '600',}}>Total do Pedido</text>
                    <text style={{width: '40%', textAlign:'right', fontSize: '17px', color: '#555', fontWeight: '600',}}>{total_ped}</text> 
                </div>
            </div>
        );
    
    }

    verificaLojaProds(strJson) {

        console.log(' ZZZZZZZ ' + strJson);
        let encodedAuth = new Buffer(strJson).toString("base64").replace(/=/g, "");
        
        try {
            // here place your signup logic     
            
            var CancelToken = axios.CancelToken;

            var valorTotal = 0;

            this.state.carrinhoCompra.map((item, index) => {
                valorTotal += (item.valorUnit * item.qtde);
            });
    
            var parametros = 
            "parvalpro="  + valorTotal +
            "&partoken="  + global.myToken +
            "&pargrures=" + global.cod_grurest +
            "&parres="    + global.cod_restaurante +
            "&parverapp=" + '99';
    
            console.log('TIMEIN');
            let source = CancelToken.source();
            setTimeout(() => {
                source.cancel();
                console.log('TIMEOUT');
            }, global.timeOutTimer);    
            
            axios.post(
                global.siteurl + 'pedido_verif_lojaprod.php', 
                parametros,
                {
                cancelToken: source.token,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded', // <-- Specifying the Content-Type
                },
                withCredentials: true,
            }).then((response) => {
                var responseData = response.data;
                this.closeProgress();

                if (responseData.resposta == "1"){

                    //this.salvaJsonPedido(JSON.stringify(jsonPedido.PEDIDO));
                    BS_ALE(this,  'Sucesso', 'Wooow it works, Hugo !!');
                    
                }else {
                    BS_ALE(this,  'Atenção', responseData.msg);
                }
            })
            .catch((error) =>{
                
                if(axios.isCancel(error)){
    
                    BS_ALE(this,  'Atenção', 'Não foi possível efetuar a solicitação, verifique sua conexão e tente novamente. \nCOD 021', [{text: 'OK', onPress: () => this.closeProgress()},],{cancelable: false},);
            
                }
                else{
            
                    BS_ALE(this,  'Atenção', 'Não foi possível efetuar a solicitação, verifique sua conexão e tente novamente. \nCOD 022', [{text: 'OK', onPress: () => this.closeProgress()},],{cancelable: false},);
            
                }
            });
        } catch (err) {
            console.log('error signing up: ', err)
        }
    }

    verificaCampos() {
        if (!this.state.formaPagamentoAtual){
            this.carregaFormasPag();
        }else if ((this.state.tipoDocNota == "nenhum")){
            this.setState({
                alertaDesejaNota: true,
            });
        }else {
            if (global.restAberto == "1"){
                this.geraPedido();
            }else{
                BS_ALE(this, 'Atenção', 
                    <div>
                        A nossa loja online não está aberta no momento.
                        <br/>
                        <br/>
                        <Link style={{textDecoration: 'underline'}} onClick={() => {
                            BS_ALE(this, 'Horários', 
                                <div style={{width: '100%'}}>
                                    <div style={{width: '215px'}}></div>
                                    {geraHorarios(global.horariosFunc)}
                                </div>
                            )
                        }}>Ver horários</Link>
                    </div>
                );
            }
        }
    }

    renderBtnAvancar() {
        if (!this.state.formaPagamentoAtual){
            return "Definir pagamento";
        }else if (!this.state.formaPagamentoAtual){
            return "Definir pagamento";
        }else {
            return "Enviar Pedido";
        }
    }

    geraPedido() {
        var jsonPedido = geraJson();

        var valor_compra = 0;

        this.state.carrinhoCompra.map((item, index) => {
            valor_compra += (item.valorUnit * item.qtde);
        });

        const desconto  = Math.floor(((valor_compra) * (global.descontoApp / 100)) * 100) / 100;

        var total_ped   = (valor_compra + this.state.taxaEntrega - desconto).toFixed(2).replace(',', '.');

        if (this.state.pagoOnline == 1){

        }else{

            var valorPag =  (this.state.formaPagamentoAtual.valTroco) ? this.state.formaPagamentoAtual.valTroco : total_ped;
            valorPag     =  valorPag.replace(',', '.');
            valorPag     =  (valorPag > 0) ? valorPag : total_ped;

            var pagoOnline = this.state.formaPagamentoAtual.online;

            jsonPedido.PEDIDO.OBSERVACAO = this.state.ped_obsped ?? '';

            jsonPedido.PEDIDO.PEDIDO = {
                HORA               : '',
                VALOR_PRE_RECEBIDO : (pagoOnline) ? valorPag : 0,
                PRE_PAGAMENTO      : (pagoOnline) ? this.state.formaPagamentoAtual.nome : '',  
                VALOR_POS_RECEBIDO : (pagoOnline) ?  0 : valorPag,
                POS_PAGAMENTO      : (pagoOnline) ? '' : this.state.formaPagamentoAtual.nome,
                VALOR_PEDIDO       : 0,
                VALOR_RECEBER      : 0,
                TAXA_ENTREGA       : 0,
                VALOR_DESCONTO     : 0,  
                BUSCAR             : global.buscar,
                PAGO               : '',
                VALOR_TROCO        : 0,  
                DATA               : '',
                PLATAFORMA         : 'Web',
                VERSAO             : global.versaoApp,
            };

            jsonPedido.PEDIDO.CLIENTE.CNPJ_CPF_CUPOM = (this.state.tipoDocNota == "nenhum") ? "" : this.state.docDocNota;
        }

        console.log('JSONzito' + ' ----- ' + JSON.stringify(jsonPedido.PEDIDO));

        //this.verificaLojaProds();
        this.salvaJsonPedido(JSON.stringify(jsonPedido.PEDIDO));
    }

    leProdutosDisponiveis(tmpProd) {
        var menuItems = [];
        const cookies = new myCookies();
    
        try {
    
          var CancelToken = axios.CancelToken;
    
          console.log('TIMEIN');
          let source = CancelToken.source();
          setTimeout(() => {
            source.cancel();
            console.log('TIMEOUT');
          }, 20000);
    
          var parametros = 'parresid=' + global.cod_restaurante;
          
          return axios.post(
            global.siteurl + 'produtos_lista.php', 
            parametros,
            {
                cancelToken: source.token,
                headers: {
                   'Content-Type': 'application/x-www-form-urlencoded', // <-- Specifying the Content-Type
                }
            }).then((response) => {
              var responseData = response.data;
              console.log('LIIIISTAAA ----- ' + responseData);
              if (responseData.resposta == '1') {
                var arrLista = JSON.parse(JSON.stringify(responseData.registros));
                var arrFinal = [];

                global.restAberto = (responseData.restaurante.aberto) ? responseData.restaurante.aberto : "0";
    
                if (responseData.promocao == '1'){
    
                  var arrProdPromo = [];
    
                  for (var index = 0; index < responseData.registros.length; index++){
                    if (index > 1){
                      for (var i = 0; i < responseData.registros[index].produtos.length; i++){
                        if ((responseData.registros[index].produtos[i].promo == "1") && ( this.comparaTexto(responseData.registros[index].produtos[i].nomeProduto, this.state.pesquisaTxt) || this.comparaTexto(responseData.registros[index].produtos[i].descricao, this.state.pesquisaTxt ) ) ){
                          arrProdPromo.push( responseData.registros[index].produtos[i] );
                        }
                      };
                    }  
                  }
    
                  arrFinal.push({
                    nome : "Promoções",
                    imagem : "",
                    info : "",
                    produtos : arrProdPromo,
                  });
                }
    
                arrLista.map((prop, key) => {
    
                  arrFinal.push({
                    nome : prop.nome,
                    misto : prop.misto,
                    imagem : prop.cor,
                    info : prop.info,
                    codigo: prop.idGrupo,
                    produtos : prop.produtos,
                    grupoAdics : prop.grupoAdics,
                  });
                  
                });
                
                var resultFunc   = global.ProductObj.copiaPedidoCarrinho(tmpProd, arrFinal);
                var indisponivel = resultFunc.indisp;

                var now = new Date();
                var time = now.getTime();
                var maxAge     = 60*60*24*40000;
                var expireTime = time + maxAge;

                var expires = (new Date(expireTime));

                cookies.set(global.cod_restaurante + '_dicaShowed', '1', { path: '/', expires: expires, maxAge: maxAge });

                if (indisponivel.length > 0){
                    this.setState({
                        alertaIndisponiveis: true,
                        prodsIndisp: indisponivel,
                        produtosDispQtd: resultFunc.dispQtd
                    });
                }else{
                    this.setState({
                        alertaIndisponiveis: true,
                        prodsIndisp: [],
                        produtosDispQtd: resultFunc.dispQtd
                    });
                }
                this.props.history.push('carrinho-compra');
              }else{
                this.setState({
                  erroDB : true,
                });
                return false;
              }
          })
          .catch((error) =>{
            if(axios.isCancel(error)){
                return false;
            }
            else{
                return false;
            }
          });
        } catch (err) {
            return false;
        }  
    
    
        
      }

    salvaJsonPedido(strJson) {

        console.log(' ZZZZZZZ ' + strJson);
        let encodedAuth = new Buffer(strJson).toString("base64").replace(/=/g, "");
        
        try {
            // here place your signup logic     
            
            var CancelToken = axios.CancelToken;
    
            var valorTotal = 0;

            this.state.carrinhoCompra.map((item, index) => {
                valorTotal += (item.valorUnit * item.qtde);
            });
    
            var parametros = 
            "parvalpro="  + valorTotal +
            "&parjson="   + encodedAuth +
            "&partoken="  + global.myToken +
            "&pargrures=" + global.cod_grurest +
            "&parres="    + global.cod_restaurante +
            "&parverapp=" + '99';
    
            console.log('TIMEIN');
            let source = CancelToken.source();
            setTimeout(() => {
                source.cancel();
                console.log('TIMEOUT');
            }, global.timeOutTimer);    
            
            axios.post(
                global.siteurl + 'pedido_salvar.php', 
                parametros,
                {
                cancelToken: source.token,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded', // <-- Specifying the Content-Type
                },
                withCredentials: true,
            }).then((response) => {
                var responseData = response.data;
                this.closeProgress();
                console.log('RETURN JSON - ' + JSON.stringify(responseData));

                if (responseData.resposta == "1"){

                    global.ProductObj.limpaCarrinho();

                    global.pedidoAtual = responseData.codigo_web;

                    if (this.state.formaPagamentoAtual.online){
                        var f = document.getElementById('Form');
                        f.parope.value = global.pedidoAtual;
                        f.parres.value = global.cod_restaurante;

                        window.open('', 'TheWindow');
                        f.submit();

                        this.props.history.push('pedido-status');
                    }else{
                        this.props.history.push('pedido-status');
                    }
                    
                }else if (responseData.resposta == 'ERRVALPROD'){
                    let tmpProd = responseData.prods;
                    BS_ALE(this,  'Atenção', 'Seu pedido não foi enviado.\nAlguns produtos que você selecionou não estão mais disponíveis');
                    this.leProdutosDisponiveis(tmpProd);
                }else {
                    BS_ALE(this,  'Atenção', responseData.msg);
                }
            })
            .catch((error) =>{
                
                if(axios.isCancel(error)){
    
                    BS_ALE(this,  'Atenção', 'Não foi possível efetuar a solicitação, verifique sua conexão e tente novamente. \nCOD 021', [{text: 'OK', onPress: () => this.closeProgress()},],{cancelable: false},);
            
                }
                else{
            
                    BS_ALE(this,  'Atenção', 'Não foi possível efetuar a solicitação, verifique sua conexão e tente novamente. \nCOD 022', [{text: 'OK', onPress: () => this.closeProgress()},],{cancelable: false},);
            
                }
            });
        } catch (err) {
            console.log('error signing up: ', err)
        }
    }

    renderMensageKG(){
        if (!global.mensagemUnidadeShowed){
            var cart = this.state.carrinhoCompra;
            var temProdutoKg = false;
    
            temProdutoKg = cart.some((produto, index) => {
                return produto.sabores.some( (sabor, index) => {
                    var saborAtual = sabor.produto;
                    return (saborAtual.unidade == "KG");
                });
            });
    
            if (temProdutoKg) {
                return (
                    <div style={{borderRadius: '8px', padding: '6px 20px', color: '#cc6d00', fontWeight: '410', margin: '10px', marginTop: '0px', fontSize: '14px', textAlign: 'justify', textJustify: 'inter-word'}}>
                        (*) {global.txtMensagemUnidade}
                    </div>
                );
            }
        }
    }

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.myBody} style={{marginTop: '0px', marginBottom: '0px', paddingBottom: '0px'}}>
                <div className={classes.container} style={{paddingBottom: '25px'}}>
                    <Card>
                        <form className={classes.form}>
                            <Header context={this} defaultIcon={false} leftLinks={
                                <div style={{ whiteSpace: 'nowrap'}}>
                                    <div style={{width: 'max-content', whiteSpace: 'nowrap', flexDirection: 'column', marginTop: '12px', marginBottom: '12px', }} className={""}>
                                        {this.renderHeader()}
                                    </div>                                    
                                </div>
                            } />
                            <CardBody>
                                {this.renderInfoCompra()}
                            </CardBody>
                        </form>                
                    </Card>
                </div>
                <Footer qtdeTiposProds={this.state.carrinhoCompra.length} whiteFont rotaAtual={this.props.location} history={this.props.history} footerExtra={
                    <div onClick={() => this.verificaCampos()} className={classes.buttonFooter}>
                        <div style={{fontWeight: '400', width: '96%', margin: '0px 2%', position: 'relative', display: 'flex'}}>
                            <div style={{position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)'}}>{this.renderBtnAvancar()}</div>
                        </div>                        
                    </div>
                } />
                <Confirmacao 
                    showAlert={this.state.alertaTroco}
                    onClose={this.handleCloseTroco}
                    callbackYes={() => {this.resolveAlertaTroco()}} 
                    title={'Atenção'}
                    msg={'Você deseja troco?'}
                    callbackNo={() => {
                        this.handleCloseTroco();
                    }}
                />

                <Confirmacao 
                    showAlert={this.state.alertaDesejaNota}
                    onClose={this.handleCloseDesejaNota}
                    callbackYes={() => {this.resolveAlertaDesejaNota()}} 
                    title={'Atenção'}
                    msg={'Você deseja inserir algum documento na Nota Fiscal?'}
                    callbackNo={() => {
                        this.setState({
                            alertaDesejaNota: false,
                        }, () => {
                            this.geraPedido();
                        })
                    }}
                />
                {this.renderDialogEndereco()}
                {this.renderDialogPagamento()}
                {this.renderDialogDocNota()}
                {this.renderDialogTroco()}

                <div style={{visibility: 'hidden'}}>
                    
                </div>

                <form id="Form" method="post" action={global.siteurl + 'mercado_pago.php?t=' + Date.now()} target="TheWindow">
                    <input type="hidden" name="parope" value="" />
                    <input type="hidden" name="parres" value="" />
                </form>

            </div>
        );
    }
}

export default withStyles(styles, { withTheme: true })(CarrinhoCompra); ;
